import { Component, DestroyRef, inject } from '@angular/core';
import { DocsRendererComponent } from '../docs-renderer/docs-renderer.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, filter, map, of, startWith, switchMap, tap} from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { DocsTreeComponent } from '../docs-tree/docs-tree.component';
import { DOCS_PREFIX } from '../docs.model';

@Component({
  selector: 'app-docs-container',
  standalone: true,
  imports: [DocsRendererComponent, AsyncPipe, DocsTreeComponent],
  templateUrl: './docs-container.component.html',
  styleUrl: './docs-container.component.scss'
})
export class DocsContainerComponent {
  router = inject(Router)
  activeRoute = inject(ActivatedRoute)
  destroyRef = inject(DestroyRef)
  httpClient = inject(HttpClient)

  currentDoc = this.router.events.pipe(
    startWith(new NavigationEnd(
      1,
      this.router.url,
      this.router.url
    )),
    filter(x => x instanceof NavigationEnd),
    switchMap(event => {
      const fullUrl = this.router.url
      const urlPrefix = DOCS_PREFIX
      if (!fullUrl.startsWith(urlPrefix)) {
        return of('# Bad Url')
      }
      let docPath = fullUrl.slice(urlPrefix.length);
      if (!docPath) {
        docPath = "/index"
      }
      const assetPath = `assets/docs${docPath}.md`

      return this.httpClient.get(assetPath, { responseType: "text"}).pipe(
        map((content,err) => {
          return content
        }),
        catchError(x => {
          return of(x.message)
        })
      )
    }),
    takeUntilDestroyed(this.destroyRef),
    startWith(""),
  )

}
